import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { Jurisdiction, JurisdictionSelector, SelfExclusionRequest, Timeout } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { SelfExclusionType } from "../../self-exclusion.const";
import { SelfExclusionService } from "../../self-exclusion.service";

import { CONTENT_KEYS } from "./self-exclusion-warning.const";

@Component({
	selector: "obg-m-self-exclusion-warning",
	templateUrl: "./self-exclusion-warning.container.html",
	styleUrls: ["./self-exclusion-warning.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelfExclusionWarningContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-self-exclusion-warning") hostCssClass = true;
	@HostBinding("attr.test-id") testId = "self-exclusion-warning-dialog";

	@Input() exclusionPeriod?: Timeout;
	@Input() centrallyExcluded?: boolean;
	@Input() selfExclusionType?: SelfExclusionType;

	@Input() handler: ((payload: SelfExclusionRequest) => void) | undefined;
	formGroup: UntypedFormGroup;
	selfExclusionDisclaimer: string | undefined;
	selfExclusionDisclaimerLpcse: string | undefined;
	isJurisdictionLpcse = false;

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CommonState>,
		private changeDetector: ChangeDetectorRef,
		private dialogRef: MatDialogRef<SelfExclusionWarningContainer>,
		private formBuilder: FormBuilder,
		private selfExclusionService: SelfExclusionService
	) {
		this.formGroup = this.formBuilder.group({
			selfExclusionDisclaimer: new UntypedFormControl(false, {
				validators: [Validators.requiredTrue],
			}),
			shouldRememberUser: false,
		});
	}

	ngOnInit() {
		const jurisdiction$ = this.store.select(JurisdictionSelector.get).pipe(
			ignoreNil(),
			tap((jurisdiction) => {
				this.isJurisdictionLpcse = jurisdiction === Jurisdiction.LPCSE;
				this.selfExclusionDisclaimer = this.isJurisdictionLpcse
					? CONTENT_KEYS.selfExclusionTermsAccept
					: this.disclaimerText();
				this.selfExclusionDisclaimerLpcse = this.disclaimerText();
			})
		);

		this.data$$ = jurisdiction$.subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	private disclaimerText() {
		return this.selfExclusionType === SelfExclusionType.Indefinite
			? CONTENT_KEYS.permanentSelfExclusionTermsLink
			: CONTENT_KEYS.temporarySelfExclusionTermsLink;
	}

	onSubmit() {
		if (this.exclusionPeriod) {
			this.selfExclusionService.handleSelfExclusion({
				days: this.exclusionPeriod.numberOfDays,
				isFromAllBrands: false,
				isCentrallySelfExcluded: this.centrallyExcluded,
			});
		}
	}

	cancelSelfExclusion() {
		this.dialogRef.close();
	}
}
